export default __webpack_public_path__ + "static/2-ad7ec003d19971d2ce5803a9b0e17672.jpeg";